import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Link, Typography } from '@mui/material';

import {
  ContentUrl,
  LegalUrl,
  TopLevelMenuUrl,
} from '@matematykagryzie/consts';

import { Address } from './address';
import { AppBadges } from '../../../../ui/src/lib/app-badges';
import { SocialCounters } from '../../../../ui/src/lib/social-counters';

export function Footer() {
  return (
    <footer>
      <Box mt={10} display="flex" flexDirection="column" alignItems="center">
        <AppBadges />
        <Box display="flex" justifyContent="center" flexWrap="wrap">
          <Box mt={4}>
            <Address />
          </Box>
          <Box
            ml={4}
            display="flex"
            flexDirection="column"
            justifyContent="center"
          >
            <ul>
              <li>
                <Link
                  component={RouterLink}
                  to={TopLevelMenuUrl.Home}
                  variant="body2"
                  color="textSecondary"
                >
                  Strona główna
                </Link>
              </li>
              <li>
                <Link
                  component={RouterLink}
                  to={TopLevelMenuUrl.Testimonials}
                  variant="body2"
                  color="textSecondary"
                >
                  Opinie
                </Link>
              </li>
              <li>
                <Link
                  component={RouterLink}
                  to={TopLevelMenuUrl.Faq}
                  variant="body2"
                  color="textSecondary"
                >
                  Najczęściej zadawane pytania
                </Link>
              </li>
              <li>
                <Link
                  component={RouterLink}
                  to={ContentUrl.Sheets}
                  variant="body2"
                  color="textSecondary"
                >
                  Arkusze maturalne z matematyki podstawowej
                </Link>
              </li>
              <li>
                <Link
                  component={RouterLink}
                  to={LegalUrl.TermsOfUse}
                  variant="body2"
                  color="textSecondary"
                >
                  Regulamin
                </Link>
              </li>
              <li>
                <Link
                  style={{
                    marginTop: 8,
                  }}
                  component={RouterLink}
                  to={LegalUrl.PrivacyPolicy}
                  variant="body2"
                  color="textSecondary"
                >
                  Polityka Prywatności
                </Link>
                <li>
                  <Link
                    style={{
                      marginTop: 8,
                    }}
                    component={RouterLink}
                    to={LegalUrl.GDPR}
                    variant="body2"
                    color="textSecondary"
                  >
                    Klauzula informacyjna rodo
                  </Link>
                </li>
              </li>
            </ul>
          </Box>
        </Box>
        <SocialCounters />
        <Box mt={1}>
          <Typography variant="body2" color="textSecondary">
            ⓒ 2021 Edubite sp. z o.o - wszystkie prawa zastrzeżone.
          </Typography>
        </Box>
      </Box>
    </footer>
  );
}

export default Footer;
